import type { IHttpProvider } from "angular";
import { module } from "angular";

export const app = module("mmHttpInterceptors", ["mmServices"]);

app.config([
    "$httpProvider",
    ($httpProvider: IHttpProvider) => {
        $httpProvider.interceptors.push("isoDateInterceptorService");
        $httpProvider.interceptors.push("timeSpanInterceptorService");
        $httpProvider.interceptors.push("irValidationInterceptorService");
    },
]);
